// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-tjcx-zzbdtjcx-nhgsZzbdtjcx-index-main_right_content-2gI_r","table":"components-tjcx-zzbdtjcx-nhgsZzbdtjcx-index-table-c7ufB"};


//////////////////
// WEBPACK FOOTER
// ./components/tjcx/zzbdtjcx/nhgsZzbdtjcx/index.css
// module id = 828
// module chunks = 0